import React, { useState } from "react";
import Slider from "react-slick";
import { RiStarFill } from "react-icons/ri";
import { HiArrowRight, HiArrowLeft } from "react-icons/hi";
import Title from "../layouts/Title";
import { quote, ReactJs, oci, dsa } from "../../assets";

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="w-14 h-12 bg-[#0c1821] hover:bg-black duration-300 rounded-md text-2xl text-gray-400 flex justify-center items-center absolute top-0 right-0 shadow-shadowOne cursor-pointer z-10"
      onClick={onClick}
    >
      <HiArrowRight />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="w-14 h-12 bg-[#0c1821] hover:bg-black duration-300 rounded-md text-2xl text-gray-400 flex justify-center items-center absolute top-0 right-20 shadow-shadowOne cursor-pointer z-10"
      onClick={onClick}
    >
      <HiArrowLeft />
    </div>
  );
}

const Testimonial = () => {
  const [dotActive, setDocActive] = useState(0);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (prev, next) => {
      setDocActive(next);
    },
    appendDots: (dots) => (
      <div
        style={{
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <ul
          style={{
            display: "flex",
            gap: "15px",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          {" "}
          {dots}{" "}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={
          i === dotActive
            ? {
                width: "12px",
                height: "12px",
                color: "blue",
                background: "#ff014f",
                borderRadius: "50%",
                cursor: "pointer",
              }
            : {
                width: "12px",
                height: "12px",
                color: "blue",
                background: "gray",
                borderRadius: "50%",
                cursor: "pointer",
              }
        }
      ></div>
    ),
  };
  return (
    <section
      id="testimonial"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title des="Certificates" />
      </div>
      <div className="max-w-6xl mx-auto">
        {/* ================ Slider One ================== */}
        <Slider {...settings}>
          <div className="w-full">
            <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
              <div className="w-full lgl:w-[60%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
                <img
                  className="h-100 md:h-50 lgl:h-90 rounded-lg object-cover"
                  src={oci}
                  alt="oci"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs uppercase text-designColor tracking-wide mb-2">
                    Oracle Cloud Infrastructure 2023 Certified Foundations
                    Associate
                  </p>
                  <h3 className="text-2xl font-bold">Issued by Oracle </h3>
                  <p className="text-base tracking-wide text-gray-500">
                    2023-2025
                  </p>
                </div>
              </div>
              <div className="w-full lgl:w-[35%] h-full flex flex-col justify-between">
                <img className="w-20 lgl:w-32" src={quote} alt="quote" />
                <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
                  <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                        Oracle Cloud Infrastructure 2023 Certified Foundations
                        Associate.
                      </h3>
                      <p className="text-base text-gray-400 mt-3">
                        28th September 2023
                      </p>
                    </div>
                    <div>
                      <a href="https://catalog-education.oracle.com/pls/certview/sharebadge?id=077109DFF24A764ED8E61F06144062ADE09432A6C2BB0593BEC00D104074D2F0">
                        View Credentials
                      </a>
                    </div>
                  </div>
                  <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                    The Oracle Cloud Infrastructure (OCI) Foundations
                    certification is for individuals who intend to demonstrate
                    fundamental knowledge of public cloud services provided by
                    Oracle Cloud Infrastructure (OCI). This certification is for
                    candidates with non-technical backgrounds, such as those
                    involved in selling or procuring cloud solutions, as well as
                    those with a technical background who want to validate their
                    foundational-level knowledge around core OCI services. This
                    exam does not require any hands-on technical experience and
                    is not a prerequisite for taking any other OCI
                    certifications.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* ================ Slider Two ================== */}

          <div className="w-full">
            <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
              <div className="w-full lgl:w-[60%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
                <img
                  className="h-100 md:h-50 lgl:h-90 rounded-lg object-cover"
                  src={ReactJs}
                  alt="ReactJs"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs uppercase text-designColor tracking-wide mb-2">
                    React Complete Developer Course with Hands-On Projects.
                  </p>
                  <h3 className="text-2xl font-bold">Issued by Udemy </h3>
                  <p className="text-base tracking-wide text-gray-500">
                    2022- current
                  </p>
                </div>
              </div>
              <div className="w-full lgl:w-[35%] h-full flex flex-col justify-between">
                <img className="w-20 lgl:w-32" src={quote} alt="quote" />
                <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
                  <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                        React Complete Developer Course with Hands-On Projects.
                      </h3>
                      <p className="text-base text-gray-400 mt-3">
                        18th November 2022
                      </p>
                    </div>
                    <div className="text-yellow-500 flex gap-1">
                      <a href="https://www.udemy.com/certificate/UC-f76dfaf7-1848-4910-a5bd-34b67e257a83/">
                        View Credentials
                      </a>
                    </div>
                  </div>
                  <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                    This certificate above verifies that Biprodas Barai
                    successfully completed the course React - Complete Developer
                    Course with Hands-On Projects on 11/18/2022 as taught by
                    YouAccel Training on Udemy. The certificate indicates the
                    entire course was completed as validated by the student. The
                    course duration represents the total video hours of the
                    course at time of most recent completion.
                  </p>
                </div>
              </div>
              <div></div>
            </div>
          </div>
          {/* ================ Slider Three ================== */}

          <div className="w-full">
            <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
              <div className="w-full lgl:w-[60%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
                <img
                  className="h-100 md:h-50 lgl:h-90 rounded-lg object-cover"
                  src={dsa}
                  alt="dsa"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs uppercase text-designColor tracking-wide mb-2">
                    JavaScript Data Structure and Algorithm.
                  </p>
                  <h3 className="text-2xl font-bold">Issued By FreeCodeCamp</h3>
                  <p className="text-base tracking-wide text-gray-500">
                    2023-current{" "}
                  </p>
                </div>
              </div>
              <div className="w-full lgl:w-[35%] h-full flex flex-col justify-between">
                <img className="w-20 lgl:w-32" src={quote} alt="quote" />
                <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
                  <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                        JavaScript Data Structure and Algorithm.
                      </h3>
                      <p className="text-base text-gray-400 mt-3">
                        6th July 2023
                      </p>
                    </div>
                    <div className="text-yellow-500 flex gap-1">
                      <a href="https://www.freecodecamp.org/certification/bipro-b/javascript-algorithms-and-data-structures">
                        View Credentials
                      </a>
                    </div>
                  </div>
                  <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                    As part of this certification, Bipro Barai built the
                    following projects and got all automated test suites to
                    pass: Certifications ,Palindrome Checker,Roman Numeral
                    Converter, Caesars Cipher, Telephone, Number Validator and
                    Cash Register.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};

export default Testimonial;
